import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tKgpco/Store/CustomHandlerCreator";

type HandlerType = CustomHandler<{ setReelQtyError: boolean }>;

export const DispatchSetReelQTYError: HandlerType = props => {
    props.dispatch({
        type: "Custom/Cart/DispatchSetReelQTYError",
        param: props.parameter.setReelQtyError,
    });
};

export const chain = [DispatchSetReelQTYError];

const setReelQtyError = createHandlerChainRunner(chain, "setReelQtyError");
export default setReelQtyError;
